import { apolloClient } from "@/vue-apollo";
import { ME } from "@/graphql/auth/queries";
import { MYPROFILE } from "@/graphql/user/queries";
// import { MYPROFILE } from "@/graphql/user/queries";
import { LOGIN_USER, REGISTER_USER } from "@/graphql/auth/mutations";
import { updateMyAccount } from '@/graphql/user/mutations'
import * as types from '../mutation-types'
import { removeNULL } from '@/js/utilities'

/**
 * Initial state
 */
export const state = {
    me: null,
    token: window.localStorage.getItem('token'),
    myProfile: null
}

/**
 * Mutations
 */
export const mutations = {
    [types.SET_USER](state, user) {
        state.me = user
    },

    [types.SET_MYPROFILE](state, user) {
        state.myProfile = user
    },

    [types.LOGOUT](state) {
        state.me = null
        state.token = null
        state.myProfile = null
        window.localStorage.removeItem('token')
    },

    [types.FETCH_USER_FAILURE](state) {
        state.me = null
        window.localStorage.removeItem('token')
    },

    [types.SET_TOKEN](state, token ) {
        state.token = token
        window.localStorage.setItem('token', token)
    }
}

/**
 * Actions
 */
export const actions = {
    async register ({ dispatch }, authDetails) {
        await apolloClient.mutate({ mutation: REGISTER_USER, variables: { ...authDetails } })
        dispatch("logout");
    },

    async login ({ commit }, authDetails) {
        const { data } = await apolloClient.mutate({ mutation: LOGIN_USER, variables: { ...authDetails } })
        commit(types.SET_TOKEN, data.login.access_token);
        commit(types.SET_USER, data.login.user);
    },

    async setLogged({ commit }, authDetails) {
        commit(types.SET_TOKEN, authDetails.access_token);
        commit(types.SET_USER, authDetails.user);
    },

    async setUser({ commit }) {
        const { data } = await apolloClient.query({ query: ME });
        commit(types.SET_USER, data.me);
    },

    async setMyProfile ({ commit }) {
        const { data } = await apolloClient.query({ query: MYPROFILE, fetchPolicy: 'no-cache' });
        // console.log(data.myProfile)
        commit(types.SET_MYPROFILE, data.myProfile);
    },

    async logout ({ commit }) {
        commit(types.LOGOUT)
        apolloClient.cache.data.clear();
    },

    async updateMyAccount({ commit }, updateMyAccountDetails = {}) {
        updateMyAccountDetails = removeNULL(updateMyAccountDetails)

        const { data } = await apolloClient.mutate({
            mutation: updateMyAccount,
            variables: { ...updateMyAccountDetails }
        });
        commit(types.SET_USER, data.updateMe);
    }
}

/**
 * Getters
 */
export const getters = {
    me: state => state.me,
    myProfile: state => state.myProfile,
    check: state => state.me !== null,
    token: state => state.token
}
